import { Modal } from 'reactstrap';

const ProcessingFeeInfoModal = ({
  isOpen,
  toggle
}) => {
  return (
    <Modal
      isOpen={isOpen}
      centered
      className="cm_g_modal_wrapper"
    >
      <div className='cm_g_modal_header'>
        <h3>Processing Fee Information</h3>
        <span onClick={toggle}>
          <i className='fa-solid fa-xmark'></i>
        </span>
      </div>

      <div className='cm_g_modal_body'>
        <div className='d-flex gap-3'>
          <div>
            <span className='bg_icon_g'>
              <i className='fa-solid fa-dollar-sign'></i>
            </span>
          </div>
          <div className='w-full'>
            <p>A flat $15 processing fee is charged on all withdrawals over $100 to cover ACH bank and cryptocurrency transfer fees.</p>
          </div>
        </div>

        <div className='bb_card'>
          <h4>Fee Structure</h4>
          <div className='d-flex justify-content-between align-items-center fee_structure'>
            <p>Withdrawals under $100:</p>
            <span>No fee</span>
          </div>
          <div className='d-flex justify-content-between align-items-center fee_structure'>
            <p>Withdrawals over $100:</p>
            <span>$15 flat fee</span>
          </div>

        </div>

        <div className="mb-4">
          <div className="d-flex align-items-center gap-3">
            <div className="gray_dot"></div>
            <div className='w-full'>
              <p>This fee never fluctuates regardless of the withdrawal amount</p>
            </div>
          </div>
          <div className="d-flex align-items-center gap-3">
            <div className="gray_dot"></div>
            <div className='w-full'>
              <p>We process all transactions in USD</p>
            </div>
          </div>
          <div className="d-flex align-items-center gap-3">
            <div className="gray_dot"></div>
            <div className='w-full'>
              <p>Any required currency conversion is carried out by your financial institution</p>
            </div>
          </div>
        </div>
        <span
          onClick={toggle}
          className='btn btn_primary w-full mt-3'
        >
          Got it
        </span>
      </div>
    </Modal>
  );
};

export default ProcessingFeeInfoModal;

